import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: /*#__PURE__*/_mergeModels({
    className: { default: '' }
  }, {
    "modelValue": {required: true},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel(__props, "modelValue");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    dense: "",
    outlined: "",
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    label: "Search for a term or code...",
    class: _normalizeClass(`${_ctx.className}-search-input`),
    for: "search-input",
    autocomplete: "off"
  }, {
    append: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_icon, {
        name: "fa-regular fa-xmark",
        class: "cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (model.value = ''))
      }, null, 512), [
        [_vShow, model.value !== '']
      ]),
      _createVNode(_component_q_separator, {
        vertical: "",
        inset: "true"
      }),
      _createVNode(_component_q_icon, { name: "fa-regular fa-magnifying-glass" })
    ]),
    _: 1
  }, 8, ["modelValue", "class"]))
}
}

})